var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/videoPause.9a499058.png","uri@2x": __webpack_public_path__ + "static/media/videoPause.9a499058.png","uri@3x": __webpack_public_path__ + "static/media/videoPause.40baca87.png",
    width: 32,
    height: 32
});